<template>
    <div class="chat-function-interaction-item">
        <svg-icon
            size="xs"
            :icon="randomIconForFunction"
            :color="'turquoise-500'"
            is-custom-icon
        />
        <div class="chat-function-interaction-item__title">
            <bar-skeleton :width="Math.floor(Math.random() * (maxWidth - minWidth + 1)) + minWidth" />
        </div>
        <div class="chat-function-interaction-item__link">
            <button
                type="button"
                disabled
            >
                <text-decorator bold :size="FontSize.xs">
                    Bekijken
                </text-decorator>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { FontSize, TextDecorator } from '@keyvue/one-ui';
    import EnvelopeIcon from '@keyvue/one-awesome-icons/icons/regular/envelope.svg?component';
    import EyeIcon from '@keyvue/one-awesome-icons/icons/regular/eye.svg?component';
    import MapLocationDotIcon from '@keyvue/one-awesome-icons/icons/regular/map-location-dot.svg?component';
    import CommentDotsIcon from '@keyvue/one-awesome-icons/icons/regular/comment-dots.svg?component';
    import MapIcon from '@keyvue/one-awesome-icons/icons/regular/map.svg?component';
    import BoltIcon from '@keyvue/one-awesome-icons/icons/regular/bolt.svg?component';
    import HouseIcon from '@keyvue/one-awesome-icons/icons/regular/house.svg?component';
    import UsersIcon from '@keyvue/one-awesome-icons/icons/regular/users.svg?component';
    import StreetViewIcon from '@keyvue/one-awesome-icons/icons/regular/street-view.svg?component';
    import ChartLineIcon from '@keyvue/one-awesome-icons/icons/regular/chart-line.svg?component';
    import MoneyBillWaveIcon from '@keyvue/one-awesome-icons/icons/regular/money-bill-wave.svg?component';
    import PiggyBankIcon from '@keyvue/one-awesome-icons/icons/regular/piggy-bank.svg?component';
    import FileInvoiceDollarIcon from '@keyvue/one-awesome-icons/icons/regular/file-invoice-dollar.svg?component';
    import PeopleGroupIcon from '@keyvue/one-awesome-icons/icons/regular/people-group.svg?component';
    import CalendarIcon from '@keyvue/one-awesome-icons/icons/regular/calendar.svg?component';
    import { computed } from 'vue';

    const icons = [
        CalendarIcon,
        BoltIcon,
        StreetViewIcon,
        ChartLineIcon,
        MoneyBillWaveIcon,
        MapIcon,
        HouseIcon,
        UsersIcon,
        EnvelopeIcon,
        CommentDotsIcon,
        PeopleGroupIcon,
        MapLocationDotIcon,
        FileInvoiceDollarIcon,
        PiggyBankIcon,
        EyeIcon,
    ];

    const randomIconForFunction = computed(() => {
        const index = Math.floor(Math.random() * icons.length);
        return icons[index];
    });

    const minWidth = 100;
    const maxWidth = 250;
</script>

<style scoped lang="scss">
    .chat-function-interaction-item {
        width: max-content;
        margin-right: 50px;
        align-self: flex-end;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: var(--theme-colors-default--turquoise-200);
        border-radius: size(xs);
        gap: size(sm);
        padding: size(sm);
        border-bottom: 1px solid var(--theme-colors-default--gray-300);
        box-shadow: 0 0 5px 0 rgba(0,0,0,0.15);

        &__title {
            font-size: font-size(sm);
        }

        &__link {
            & > button {
                display: inline-block;
                border: none;
                background: none;
                padding: 0;
                color: var(--theme-colors-default--turquoise-500);

                &:hover {
                    color: var(--button-text-hover-color);
                }
            }
        }
    }
</style>
